import React, { useEffect, useRef, useState, useMemo } from "react";
import debounce from "lodash.debounce";
import { LiaSearchSolid } from "react-icons/lia";
import useTitanApp from "../../hooks/useTitanApp";
import {
  setCurrentKanbanChecks,
  setCurrentKanbanInbox,
  setFilterNameData,
} from "../../dispatchers/clinicalChecksDispatchers";

function CheckNameFilter({ filterPatientData }) {
  const inputRef = useRef(null);

  const { clincicalChecksState } = useTitanApp();
  const { filterNameValues, kanbanInbox, KanbanChecks } =
    clincicalChecksState || {};

  const [originalKanbanInbox, setOriginalKanbanInbox] = useState([]);
  const [originalKanbanChecks, setOriginalKanbanChecks] = useState([]);

  useEffect(() => {
    if (kanbanInbox?.length > 0 && originalKanbanInbox?.length === 0) {
      setOriginalKanbanInbox(kanbanInbox);
    }
    if (KanbanChecks?.length > 0 && originalKanbanChecks?.length === 0) {
      setOriginalKanbanChecks(KanbanChecks);
    }
  }, [kanbanInbox, KanbanChecks]);

  useEffect(() => {
    setFilterNameData("");
  }, []);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const filterPatientDataRef = useRef(filterPatientData);
  filterPatientDataRef.current = filterPatientData;

  const debouncedFilter = useMemo(
    () => debounce((value) => filterPatientDataRef.current(value), 300),
    [],
  );

  useEffect(() => () => debouncedFilter.cancel(), [debouncedFilter]);

  function handleSearchName(e) {
    const value = e.target.value;
    setFilterNameData(value);
    debouncedFilter(value);
  }

  return (
    <div className="inputDiv">
      <input
        id="searchname"
        name="searchname"
        type="text"
        className="searchPatient"
        placeholder="Search by patient name..."
        value={filterNameValues}
        onChange={handleSearchName}
        autoComplete="off"
        ref={inputRef}
      />
      <span className="searchIcon">
        <LiaSearchSolid size={15} className="icons-color" />
      </span>
    </div>
  );
}

export default CheckNameFilter;
